import { Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output, inject, DestroyRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import * as _ from 'lodash-es';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import { JsonObjectFactoryService } from '../../../global/services/json-object-factory.service';
import { AddNewTagService } from './add-new-tag.service';
import {
  buildHeaderDataShell,
  normalizeFilterParams,
} from '../../../shared/workspace-element-context';
import {
  AppkitDropdownItem,
  handleAppkitValueSelect
} from '../../../shared/utils/appkit-dropdown.util';
import {
  handleNamedDropdownSelect,
  refreshNamedDropdown,
  setFormDropdownAriaLabel
} from '../../shared/ftc-form-dropdown.support';

@Component({
    selector: 'gtw-add-new-tag',
    templateUrl: './add-new-tag.component.html',
    styleUrls: ['./add-new-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AddNewTagComponent implements OnInit, OnDestroy {
  setFormDropdownAriaLabel = setFormDropdownAriaLabel;
  entityOptionsView: AppkitDropdownItem[] = [];
  grossIncExpDataView: AppkitDropdownItem[] = [];
  transCategoryDataView: AppkitDropdownItem[] = [];
  basketCodeDataView: AppkitDropdownItem[] = [];
  sicCodeDataView: AppkitDropdownItem[] = [];
  fdiiCodeDataView: AppkitDropdownItem[] = [];
  filteredTaxYearDataView: AppkitDropdownItem[] = [];
  lineNoCodeDataView: AppkitDropdownItem[] = [];
  yesNoDataView: AppkitDropdownItem[] = [];
  beatTypeDataView: AppkitDropdownItem[] = [];
  relatedCodeDataView: AppkitDropdownItem[] = [];
  tradingPartnerOptionsView: AppkitDropdownItem[] = [];
  countryCodeDataView: AppkitDropdownItem[] = [];
  htkoDataView: AppkitDropdownItem[] = [];
  fsiDataView: AppkitDropdownItem[] = [];
  sourceTypeCodeDataView: AppkitDropdownItem[] = [];
  projectTagCodeDataView: AppkitDropdownItem[] = [];
  methodCodeDataView: AppkitDropdownItem[] = [];
  baseFDIIDataView: AppkitDropdownItem[] = [];
  basketCodeAllocateDataView: AppkitDropdownItem[] = [];
  baseLevelDataView: AppkitDropdownItem[] = [];
  baseEntityDataView: AppkitDropdownItem[] = [];
  selectedCodeCombinationItem: AppkitDropdownItem | null = null;
  selectedGrossIncExpItem: AppkitDropdownItem | null = null;
  selectedTransCatItem: AppkitDropdownItem | null = null;
  selectedBasketCodeItem: AppkitDropdownItem | null = null;
  selectedSicCodeItem: AppkitDropdownItem | null = null;
  selectedFdiiCodeItem: AppkitDropdownItem | null = null;
  applicableYearKeyItem: AppkitDropdownItem | null = null;
  selectedLineNoItem: AppkitDropdownItem | null = null;
  selectedBeatCodeItem: AppkitDropdownItem | null = null;
  selectedBeatTypeCodeItem: AppkitDropdownItem | null = null;
  selectedRelatedCodeItem: AppkitDropdownItem | null = null;
  selectedTradingPartnerCodeItem: AppkitDropdownItem | null = null;
  selectedCountryCodeItem: AppkitDropdownItem | null = null;
  selectedHtkoCodeItem: AppkitDropdownItem | null = null;
  selectedFsiCodeItem: AppkitDropdownItem | null = null;
  selectedSourceTypeCodeItem: AppkitDropdownItem | null = null;
  selectedProjectTaggingCodeItem: AppkitDropdownItem | null = null;
  selectedMethodCodeItem: AppkitDropdownItem | null = null;
  selectedBaseFdiiCodesItem: AppkitDropdownItem | null = null;
  selectedBaseBasketCodeItem: AppkitDropdownItem | null = null;
  selectedBaseLevelCodeItem: AppkitDropdownItem | null = null;
  selectedBaseEntityLevelCodeItem: AppkitDropdownItem | null = null;

  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  private readonly subs = new Subscription();
  private isInitialized = false;
  GENERAL_CONFIG: any = {};
  private globalParams: any = {};
  filterParams: any = {};
  private userSettings: any = {};

  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  private isSourceFlag = false;
  loadingData = true;
  loadingDataAdd: boolean | undefined;
  isError = false;

  logged_in_user = '';
  curentyear = '';
  scenario = '';
  jcd_key: any;
  QARScenario = 'N';

  // Entity / GIE / Trans Category selections
  codeCombinationData: any[] = [];
  grossIncExpData: any[] = [];
  transCategoryData: any[] = [];
  selectedCodeCombination: any;
  selectedGrossIncExp: any;
  selectedTransCat: any;

  // Dynamic field visibility
  newArray: string[] = [];
  getAttribToDisplay: any[] = [];

  // Dropdown data from code mast (31hizx)
  basketCodeData: any[] = [];
  basketCodeAllocateData: any[] = [];
  sicCodeData: any[] = [];
  fdiiCodeData: any[] = [];
  taxYearData: any[] = [];
  filteredTaxYearData: any[] = [];
  sourceTypeCodeData: any[] = [];
  projectTagCodeData: any[] = [];
  yesNoData: any[] = [];
  beatTypeData: any[] = [];
  relatedCodeData: any[] = [];
  countryCodeData: any[] = [];
  htkoData: any[] = [];
  fsiData: any[] = [];
  baseFDIIData: any[] = [];
  baseBasketData: any[] = [];
  baseLevelData: any[] = [];
  baseEntityData: any[] = [];
  baseBasketTypeData: any[] = [];
  basefdiiSingleMultiData: any[] = [];
  baseTypeCodeData: any[] = [];
  lineNoCodeData: any[] = [];
  methodCodeData: any[] = [];
  attribMastData: any[] = [];
  allTransCategoryData: any[] = [];
  allGPTransCategoryData: any[] = [];
  baseTypeData: any[] = [];
  dropdownLists: { [k: string]: any[] } = { baseFDII: [], baseBasket: [], baseType: [] };
  tradingPartnerCodeData: any[] = [];
  beatYesforeignTradingPartnerData: any[] = [];
  beatNoforeignTradingPartnerData: any[] = [];
  domesticTradingPartnerData: any[] = [];
  fseCompDefaultData: any[] = [];
  allDefaultData: any[] = [];
  singleBaseFDIIData: any[] = [];
  singleBaseBasketData: any[] = [];

  // PrimeNG dropdown options
  entityOptions: any[] = [];
  tradingPartnerOptions: any[] = [];

  // Selected values
  selectedBasketCode: any;
  selectedBasketCodeDesc = '';
  selectedSicCode: any;
  selectedFdiiCode: any;
  applicableYearKey: any;
  selectedLineNo: any;
  selectedBeatCode: any;
  selectedBeatCodeDesc = '';
  selectedBeatTypeCode: any;
  selectedBeatWithhold: any;
  selectedRelatedCode: any;
  selectedRelatedCodeDesc = '';
  selectedTradingPartnerCode: any;
  selectedTradingPartnerLEID: any;
  selectedCountryCode: any;
  selectedHtkoCode: any;
  selectedFsiCode: any;
  selectedSourceTypeCode: any;
  selectedProjectTaggingCode: any;
  selectedNotes: any;
  selectedMethodCode: any;
  selectedBaseFdiiCodes: any;
  selectedBaseFdiiCodesCopy: any;
  selectedBaseBasketCode: any;
  selectedBaseBasketCodeCopy: any;
  selectedBaseTypeCode: any[] = [];
  selectedBaseLevelCode: any;
  selectedBaseEntityLevelCode: any;

  // Flags
  displaySingleSelectBase = '';
  gIncomeMethodFlag = '';
  disableCountry = '';
  disableFSE: string | undefined;
  disableBaseLevels = '';
  basketCodeDisable: any;
  addFlag = true;
  selectedGieName = '';
  transCatgIsChangedFlag = 'N';
  transCatgMapDesc = '';
  showWarning = 'N';
  isMethodChangedManually = false;
  AllocateMethodTransCatg = false;
  manualTransCategory = false;
  flagForNewUpdate = -1;

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private _snackBar: MatSnackBar, private gtwSnackbar: GtwSnackbarService,
    private jsonObjectFactory: JsonObjectFactoryService,
    private addNewTagService: AddNewTagService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => {
      this.applyWorkspaceContext();
      this.tryInit();
    }));
    this.tryInit();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private applyWorkspaceContext(): void {
    this.isInitialized = false;
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.globalParams = header.globalParams || {};
    this.userSettings = header.userSettingsData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    this.isInitialized = true;

    this.logged_in_user = this.userSettings?.user?.sso_id || this.userSettings?.sso_id || '';
    this.curentyear = this.filterParams.tax_year;
    this.scenario = this.filterParams.scenario;
    this.jcd_key = this.globalParams.jcd_key;

    this.checkLockStatus();
    this.getCodeCombinationData();
  }

  /* ─── Lock Check (n10cpv) ─── */

  private checkLockStatus(): void {
    const lockparams = {
      action_code: 'n10cpv',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', lockparams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.jsonObject) {
        const lockData = data.jsonObject;
        if (lockData?.[0]?.LOCK_STATUS === 'Y') {
          this.cancel();
          this.gtwSnackbar.openSnackBar('Tax Return has already been filed for tax year ' + this.curentyear + '.', 'gtw-snackbar--red', true, 4);
          return;
        }
        if (lockData?.[0]?.SCENARIO_DESC === 'EXAM') {
          this.QARScenario = 'Y';
          this.cancel();
          this.gtwSnackbar.openSnackBar('Create Tag is not available for selected Scenario.', 'gtw-snackbar--red', true, 4);
          return;
        }
      }
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Entity list (g9oqag) ─── */

  getCodeCombinationData(): void {
    const params = {
      action_code: 'g9oqag',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.codeCombinationData = data?.jsonObject || [];
      // `value` must stay a primitive: the AppKit searchbox and the projected
      // list-item filter both key off String(item.value), and an object value
      // collapses every entity to "[object Object]".
      this.entityOptions = this.codeCombinationData.map((e: any) => ({
        ...e,
        label: e.VALUE,
        value: e.KEY,
      }));
      this.getGrossIncExpData();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Gross Inc/Exp list (24mnso) ─── */

  getGrossIncExpData(): void {
    const params = { action_code: '24mnso' };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      this.grossIncExpData = data?.jsonObject || [];
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Trans Category list (1sdudl) ─── */

  getTransCategoryData(): void {
    if (!this.selectedCodeCombination || !this.selectedGrossIncExp) return;
    const params = {
      action_code: '1sdudl',
      cc_key: this.selectedCodeCombination.KEY,
      gie_name: this.selectedGrossIncExp.GIE_NAME,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.transCategoryData = data?.jsonObject || [];
      this.baseTypeData = data?.jsonObject || [];
      this.syncDropdownList('baseType', this.baseTypeData);
      this.resetDependentFields();
      this.getCodeMastData();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Code Mast Data (31hizx) ─── */

  getCodeMastData(): void {
    if (!this.selectedCodeCombination) return;
    const params = {
      action_code: '31hizx',
      cc_key: this.selectedCodeCombination.KEY,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      const jsonObj = data?.jsonObject || [];
      this.basketCodeData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.basketCodeAllocateData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE_ALLOCATE'], p.CODE_GROUP));
      _.remove(this.basketCodeAllocateData, { CODE_DESCRIPTION: 'Default' });
      this.fdiiCodeData = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
      this.sicCodeData = _.filter(jsonObj, (p: any) => _.includes(['SIC_CODE_PER_ME'], p.CODE_GROUP));
      if (this.sicCodeData.length <= 1) {
        this.sicCodeData = _.filter(jsonObj, (p: any) => _.includes(['SIC_CODE'], p.CODE_GROUP));
      }
      this.taxYearData = _.filter(jsonObj, (p: any) => _.includes(['TAX_YEAR'], p.CODE_GROUP));
      this.sourceTypeCodeData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_TYPE_CODE'], p.CODE_GROUP));
      this.projectTagCodeData = _.filter(jsonObj, (p: any) => _.includes(['PROJECT_TAG_CODE'], p.CODE_GROUP));
      this.yesNoData = _.filter(jsonObj, (p: any) => _.includes(['YES_NO'], p.CODE_GROUP));
      this.beatTypeData = _.filter(jsonObj, (p: any) => _.includes(['BEAT_TYPE_CODE'], p.CODE_GROUP));
      this.relatedCodeData = _.filter(jsonObj, (p: any) => _.includes(['RELATED_CODE'], p.CODE_GROUP));
      this.countryCodeData = _.filter(jsonObj, (p: any) => _.includes(['COUNTRY_CODE'], p.CODE_GROUP));
      this.htkoData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.fsiData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      this.baseFDIIData = _.filter(jsonObj, (p: any) => _.includes(['FDII_CODE'], p.CODE_GROUP));
      this.baseBasketData = _.filter(jsonObj, (p: any) => _.includes(['SOURCE_CODE'], p.CODE_GROUP));
      _.remove(this.baseBasketData, { CODE_DESCRIPTION: 'Default' });
      this.syncDropdownList('baseFDII', this.baseFDIIData);
      this.syncDropdownList('baseBasket', this.baseBasketData);
      this.baseLevelData = _.filter(jsonObj, (p: any) => _.includes(['BASE_LEVEL_CODE'], p.CODE_GROUP));
      this.baseEntityData = _.filter(jsonObj, (p: any) => _.includes(['BASE_ENTITY_CODE'], p.CODE_GROUP));
      this.baseBasketTypeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_BASKET_CODE'], p.CODE_GROUP));
      this.baseTypeCodeData = _.filter(jsonObj, (p: any) => _.includes(['BASE_TYPE_CODE'], p.CODE_GROUP));
      this.basefdiiSingleMultiData = _.filter(jsonObj, (p: any) => _.includes(['BASE_FDII_CODE'], p.CODE_GROUP));
      this.lineNoCodeData = _.filter(jsonObj, (p: any) => _.includes(['LINE_NO_CODE'], p.CODE_GROUP));

      this.tillCurrentTaxYear(Number(this.curentyear), 0, 11);
      this.getAttribNamebyGieName();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Attribute Display Names (6qd7am) ─── */

  getAttribNamebyGieName(): void {
    if (!this.selectedGrossIncExp) return;
    const gieName = this.selectedGrossIncExp.GIE_NAME;
    const params = { action_code: '6qd7am', gie_name: gieName };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.getAttribToDisplay = data?.jsonObject || [];
      this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      this.getAttribMast();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Attribute Master (2nk5nz) ─── */

  getAttribMast(): void {
    const params = { action_code: '2nk5nz' };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.attribMastData = data?.jsonObject || [];
      this.getTradingPartnerData();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Trading Partner Data (ayqh3u) ─── */

  getTradingPartnerData(): void {
    const params = {
      action_code: 'ayqh3u',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.tradingPartnerCodeData = data?.jsonObject || [];
      this.beatYesforeignTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_FGN_BEAT_YES'], p.CODE_GROUP)
      );
      this.beatNoforeignTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_FGN_BEAT_NO'], p.CODE_GROUP)
      );
      this.domesticTradingPartnerData = _.filter(this.tradingPartnerCodeData, (p: any) =>
        _.includes(['RELATED_DOMESTIC'], p.CODE_GROUP)
      );
      this.rebuildTradingPartnerOptions();
      this.getMethod();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: Method codes (lwtsx1) ─── */

  getMethod(): void {
    if (!this.selectedGrossIncExp) return;
    const params = {
      action_code: 'lwtsx1',
      gie_key: this.selectedGrossIncExp.GIE_KEY,
      p_scenario: this.scenario,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.methodCodeData = data?.jsonObject || [];
      this.getAllTransCatgExceptExp();
      this.getDefaultsPopulateData();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── API: All Trans Categories except Exp (9aszao) ─── */

  getAllTransCatgExceptExp(): void {
    const params = {
      action_code: '9aszao',
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.allTransCategoryData = data?.jsonObject || [];
      this.allGPTransCategoryData = _.filter(this.allTransCategoryData, (p: any) =>
        _.includes(['GPROFIT'], p.GIE_NAME)
      );
      this.getFSECompDefData();
      this.cdr.detectChanges();
    });
  }

  /* ─── API: Defaults Populate Data (4tivvr) ─── */

  getDefaultsPopulateData(): void {
    if (!this.selectedCodeCombination || !this.selectedGrossIncExp) return;
    const cckey = this.selectedCodeCombination.KEY;
    const params = {
      action_code: '4tivvr',
      gie_key: this.selectedGrossIncExp.GIE_KEY,
      cc_key: cckey,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.allDefaultData = data?.jsonObject || [];
      this.applyDefaults();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  private applyDefaults(): void {
    // SIC Code
    if (this.selectedSicCode == undefined || this.selectedSicCode === '' || this.addFlag) {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'SIC_CODES']);
      if (dv) {
        const ex = _.find(this.sicCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedSicCode = ex.CODE_KEY;
      }
    }
    // Basket
    if (this.selectedBasketCode == undefined || this.selectedBasketCode === '' || this.addFlag) {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASKET']);
      if (dv) {
        const ex = _.find(this.basketCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedBasketCode = ex.CODE_KEY;
      }
    }
    // FDII
    if (this.selectedFdiiCode == undefined || this.selectedFdiiCode === '' || this.addFlag) {
      const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'FDII']);
      if (dv) {
        const ex = _.find(this.fdiiCodeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
        if (ex) this.selectedFdiiCode = ex.CODE_KEY;
      }
    }
    // Method
    if (this.selectedMethodCode == undefined || this.selectedMethodCode === '') {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'METHOD']);
      if (exists) {
        const mc = _.find(this.methodCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (mc) this.selectedMethodCode = mc;
      }
    }
    // Base Level
    if (this.selectedBaseLevelCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASE_LEVEL']);
      if (exists) {
        const bl = _.find(this.baseLevelData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (bl) this.selectedBaseLevelCode = bl.CODE_KEY;
      }
    }
    // Base Entity Level
    if (this.selectedBaseEntityLevelCode == undefined) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BASE_ENTITY_LEVEL']);
      if (exists) {
        const be = _.find(this.baseEntityData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (be) this.selectedBaseEntityLevelCode = be.CODE_KEY;
      }
    }
    // Base Basket default
    if (this.selectedBaseBasketCode == undefined || this.selectedBaseBasketCode === '') {
      const defaultBB = _.filter(this.allDefaultData, (p: any) => _.includes(['BASE_BASKET'], p.ATTRIB_NAME));
      if (defaultBB?.length > 0 && this.baseBasketData?.length > 0) {
        const temp: any[] = [];
        defaultBB.forEach((d: any) => {
          this.baseBasketData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) temp.push(m);
          });
        });
        this.selectedBaseBasketCode = this.uniqueData(temp, 'CODE_KEY');
        this.selectedBaseBasketCodeCopy = _.cloneDeep(this.selectedBaseBasketCode);
      }
    }
    // Base FDII default
    if (this.selectedBaseFdiiCodes == undefined || this.selectedBaseFdiiCodes === '') {
      const defaultFdii = _.filter(this.allDefaultData, (p: any) => _.includes(['BASE_FDII'], p.ATTRIB_NAME));
      if (defaultFdii?.length > 0 && this.baseFDIIData?.length > 0) {
        const temp: any[] = [];
        defaultFdii.forEach((d: any) => {
          this.baseFDIIData.forEach((m: any) => {
            if (m.CODE_KEY === d.CODE_KEY) temp.push(m);
          });
        });
        this.selectedBaseFdiiCodes = this.uniqueData(temp, 'CODE_KEY');
        this.selectedBaseFdiiCodesCopy = _.cloneDeep(this.selectedBaseFdiiCodes);
      }
    }
    // Beat
    if (this.selectedBeatCode == undefined || this.addFlag) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BEAT']);
      if (exists) {
        const yn = _.find(this.yesNoData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (yn) {
          this.selectedBeatCode = yn.CODE_KEY;
          this.selectedBeatCodeDesc = yn.CODE_DESCRIPTION;
        }
      }
    }
    // Source Type
    if (this.selectedSourceTypeCode == undefined || this.addFlag) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'SOURCE_TYPE']);
      if (exists) {
        const st = _.find(this.sourceTypeCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (st) this.selectedSourceTypeCode = st.CODE_KEY;
      }
    }
    // Related/Unrelated
    if (this.selectedRelatedCode == undefined || this.addFlag) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'RELATED_UNRELATED']);
      if (exists) {
        const rc = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', exists.CODE_DESCRIPTION]);
        if (rc) {
          this.selectedRelatedCode = rc.CODE_KEY;
          this.selectedRelatedCodeDesc = rc.CODE_DESCRIPTION;
        }
      }
    }
    // Country
    if (this.selectedCountryCode == undefined || this.selectedCountryCode === '' || this.addFlag) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'COUNTRY']);
      if (exists) {
        const cc = _.find(this.countryCodeData, ['CODE_DESC', exists.CODE_DESCRIPTION]);
        if (cc) this.selectedCountryCode = cc.CODE_KEY;
      }
    }
    // Line No
    if (this.selectedLineNo == undefined || this.selectedLineNo === '' || this.addFlag) {
      const exists = _.find(this.allDefaultData, ['ATTRIB_NAME', 'LINE_NO']);
      if (exists) {
        const ln = _.find(this.lineNoCodeData, ['CODE_DESC', exists.CODE_DESCRIPTION]);
        if (ln) this.selectedLineNo = ln.CODE_KEY;
      }
    }
  }

  /* ─── API: FSE Component Default Data (8kj84y) ─── */

  getFSECompDefData(): void {
    if (!this.selectedCodeCombination) return;
    const cckey = this.selectedCodeCombination.KEY;
    const params = {
      action_code: '8kj84y',
      cc_key: cckey,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', params
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      if (data?.errorMessage && data.errorMessage.length > 0 && data.errorMessage !== 'null') {
        this.gtwSnackbar.openSnackBar(data.errorMessage, 'gtw-snackbar--red', true, 4);
        return;
      }
      this.fseCompDefaultData = data?.jsonObject || [];
      this.validations();
          this.refreshFormDropdowns();
    this.cdr.detectChanges();
    });
  }

  /* ─── Validations ─── */

  private validations(): void {
    _.remove(this.htkoData, { CODE_DESCRIPTION: 'Passive' });
    _.remove(this.fsiData, { CODE_DESCRIPTION: 'Passive' });

    if (this.selectedGrossIncExp) {
      const gieName = this.selectedGrossIncExp.GIE_NAME;
      const gieType = this.selectedGrossIncExp.GIE_TYPE;
      if (gieName !== 'GPROFIT') {
        _.remove(this.sourceTypeCodeData, { CODE_DESCRIPTION: 'Summary' });
      }
      if (gieType === 'INC' || gieType === 'INVESTMENTS') {
        _.remove(this.sourceTypeCodeData, { CODE_DESCRIPTION: 'Percentage' });
      }
    }
    this.loadingData = false;
    this.loadingDataAdd = false;
  }

  /* ─── Tax Year filter ─── */

  private tillCurrentTaxYear(curentYr: number, fromPriorYr: number, tillPriorYr: number): void {
    this.filteredTaxYearData = [];
    for (const ty of this.taxYearData) {
      if (ty.CODE_GROUP === 'TAX_YEAR' &&
          ty.CODE_DESC <= (curentYr - fromPriorYr) &&
          ty.CODE_DESC >= (curentYr - tillPriorYr)) {
        this.filteredTaxYearData.push(ty);
      }
    }
    this.applicableYearKey = this.getTaxYearKey(this.filterParams.tax_year);
  }

  private getTaxYearKey(taxYearDesc: string): string | undefined {
    for (const ty of this.taxYearData) {
      if (ty.CODE_DESC == taxYearDesc) {
        return '' + ty.CODE_KEY;
      }
    }
    return undefined;
  }

  /* ─── Change Handlers ─── */

  changeEntity(): void {
    this.selectedGrossIncExp = undefined;
    this.selectedTransCat = undefined;
    this.selectedBasketCode = undefined;
    this.selectedSicCode = undefined;
    this.selectedFdiiCode = undefined;
    this.selectedBeatTypeCode = undefined;
    this.selectedRelatedCode = undefined;
    this.selectedTradingPartnerCode = undefined;
    this.selectedCountryCode = undefined;
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.selectedSourceTypeCode = undefined;
    this.selectedProjectTaggingCode = undefined;
    this.selectedNotes = undefined;
    this.selectedMethodCode = undefined;
    this.selectedBaseFdiiCodes = undefined;
    this.selectedBaseBasketCode = undefined;
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = undefined;
    this.selectedBaseEntityLevelCode = undefined;
    this.selectedBeatWithhold = undefined;
    this.selectedBeatCode = undefined;
    this.selectedBeatCodeDesc = '';
    this.selectedRelatedCodeDesc = '';
    this.newArray = [];
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  onGrossIncExpChange(): void {
    this.selectedTransCat = undefined;
    this.selectedBasketCode = undefined;
    this.selectedSicCode = undefined;
    this.selectedFdiiCode = undefined;
    this.selectedBeatTypeCode = undefined;
    this.selectedBeatCodeDesc = '';
    this.selectedRelatedCode = undefined;
    this.selectedTradingPartnerCode = undefined;
    this.selectedCountryCode = undefined;
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.selectedSourceTypeCode = undefined;
    this.selectedProjectTaggingCode = undefined;
    this.selectedNotes = undefined;
    this.selectedMethodCode = undefined;
    this.selectedBaseFdiiCodes = undefined;
    this.selectedBaseBasketCode = undefined;
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = undefined;
    this.selectedBaseEntityLevelCode = undefined;
    this.selectedBeatWithhold = undefined;

    if (this.selectedGrossIncExp?.GIE_NAME !== 'GPROFIT') {
      _.remove(this.sourceTypeCodeData, { CODE_DESCRIPTION: 'Summary' });
    }
    this.getTransCategoryData();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  updateCountryField(manual?: boolean): void {
    this.manualTransCategory = manual ? true : false;
    if (this.loadingDataAdd == undefined) this.loadingDataAdd = true;
    this.disableBaseLevels = '';
    this.isMethodChangedManually = false;

    const exists = _.find(this.transCategoryData, ['CODE_KEY', this.selectedTransCat]);
    if (exists) {
      this.transCatgIsChangedFlag = exists.IS_CHANGED;
      this.transCatgMapDesc = exists.MAP_DESC;
      this.showWarning = exists.SHOW_WARINING;
    }

    if (this.transCatgIsChangedFlag === 'N' || this.transCatgMapDesc === 'Y') {
      this.removeSetAttributes();
    }
    this.cdr.detectChanges();
  }

  removeSetAttributes(): void {
    const servicesExists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', 'Services']);
    const transCatgKeyService = servicesExists ? servicesExists.CODE_KEY : undefined;
    const prorateExists = _.find(this.transCategoryData, ['CODE_DESCRIPTION', 'Prorate Variance']);
    const transCatgKeyProrate = prorateExists ? prorateExists.CODE_KEY : undefined;

    const gieName = this.selectedGrossIncExp?.GIE_NAME || '';

    if (this.getAttribToDisplay == undefined || this.getAttribToDisplay.length === 0) {
      this.getAttribNamebyGieName();
      return;
    }

    if (gieName === 'GPROFIT' && transCatgKeyProrate == this.selectedTransCat && this.getAttribToDisplay) {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'SIC Code' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'HTKO' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'FSE' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      this.disableBaseLevels = 'Yes';
    } else if (gieName === 'GPROFIT' && transCatgKeyService == this.selectedTransCat && this.getAttribToDisplay) {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Method' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
    } else if (gieName === 'GPROFIT' && this.getAttribToDisplay) {
      const newList = _.cloneDeep(this.getAttribToDisplay);
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
      _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Method' });
      this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
    } else {
      if (this.getAttribToDisplay) {
        if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION !== 'Allocate'
            && this.selectedMethodCode.CODE_DESCRIPTION !== 'Interest Expense') {
          this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
        }
      }
    }
    this.cdr.detectChanges();
  }

  changeBasketCode(): void {
    const exists1 = _.find(this.basketCodeData, ['CODE_DESCRIPTION', 'Passive']);
    if (exists1) {
      this.basketCodeDisable = exists1.CODE_KEY;
    }

    if (this.fseCompDefaultData.length === 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'true';
    } else if (this.fseCompDefaultData.length > 0 && this.basketCodeDisable == this.selectedBasketCode) {
      this.disableFSE = 'false';
    } else {
      this.disableFSE = undefined;
    }

    const exists = _.find(this.basketCodeData, ['CODE_KEY', this.selectedBasketCode]);
    if (exists) {
      this.selectedBasketCodeDesc = exists.CODE_DESCRIPTION;
    }

    _.remove(this.htkoData, { CODE_DESCRIPTION: 'Passive' });
    _.remove(this.fsiData, { CODE_DESCRIPTION: 'Passive' });
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.cdr.detectChanges();
  }

  changeBeatCode(): void {
    const exists = _.find(this.yesNoData, ['CODE_KEY', this.selectedBeatCode]);
    if (exists) {
      this.selectedBeatCodeDesc = exists.CODE_DESCRIPTION;
    } else {
      this.selectedBeatCodeDesc = '';
      this.selectedBeatTypeCode = '';
      this.selectedRelatedCode = '';
      this.selectedRelatedCodeDesc = '';
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';
      this.selectedBeatWithhold = undefined;
    }

    if (this.selectedBeatCodeDesc === 'Yes') {
      const relFgn = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', 'Related Foreign']);
      if (relFgn) {
        this.selectedRelatedCode = relFgn.CODE_KEY;
        this.selectedRelatedCodeDesc = 'Related Foreign';
      }
      this.disableCountry = 'Yes';
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';

      if (this.selectedBeatTypeCode == undefined || this.selectedBeatTypeCode === '' || this.addFlag) {
        const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'BEAT_TYPE']);
        if (dv) {
          const bt = _.find(this.beatTypeData, ['CODE_DESCRIPTION', dv.CODE_DESCRIPTION]);
          if (bt) this.selectedBeatTypeCode = bt.CODE_KEY;
        }
      }
    } else if (this.selectedBeatCodeDesc === 'No') {
      this.selectedBeatTypeCode = '';
      this.selectedBeatWithhold = undefined;
      this.selectedTradingPartnerCode = '';
      this.selectedCountryCode = '';
    }
    this.rebuildTradingPartnerOptions();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeRelatedCode(): void {
    this.selectedCountryCode = '';
    const exists = _.find(this.relatedCodeData, ['CODE_KEY', this.selectedRelatedCode]);
    if (exists) {
      this.selectedRelatedCodeDesc = exists.CODE_DESCRIPTION;
    }

    if (this.selectedRelatedCodeDesc === 'Related Domestic') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = 'Yes';
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = 'Yes';
    }
    if (this.selectedRelatedCodeDesc === 'UnRelated') {
      this.selectedTradingPartnerCode = '';
      this.disableCountry = '';
      if (this.selectedCountryCode == undefined || this.selectedCountryCode === '') {
        const dv = _.find(this.allDefaultData, ['ATTRIB_NAME', 'COUNTRY']);
        if (dv) {
          const cc = _.find(this.countryCodeData, ['CODE_DESC', dv.CODE_DESCRIPTION]);
          if (cc) this.selectedCountryCode = cc.CODE_KEY;
        }
      }
    }
    if (this.selectedBeatCodeDesc == undefined) {
      this.selectedBeatCodeDesc = '';
    }
    this.rebuildTradingPartnerOptions();
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeTradingPartner(): void {
    const exists = _.find(this.tradingPartnerCodeData, ['COMBINATION_KEY', this.selectedTradingPartnerCode]);
    if (exists) {
      this.selectedTradingPartnerLEID = exists.COMBINATION_KEY;
      const cExists = _.find(this.countryCodeData, ['CODE_SHORT_DESC', exists.LE_COUNTRY]);
      if (cExists) {
        this.selectedCountryCode = cExists.CODE_KEY;
      } else {
        this.selectedCountryCode = '';
      }
    }
    this.cdr.detectChanges();
  }

  changeInCreateMethod(): void {
    this.isMethodChangedManually = true;
    this.changeMethod();
  }

  changeMethod(): void {
    this.displaySingleSelectBase = '';
    this.gIncomeMethodFlag = '';
    this.selectedGieName = this.selectedGrossIncExp ? this.selectedGrossIncExp.GIE_NAME : '';

    if (this.selectedGieName && (this.selectedGieName === 'INTEXP' || this.selectedGieName === 'RESEARCH')) {
      if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Allocate') {
        this.displaySingleSelectBase = 'true';
        const newList = _.cloneDeep(this.getAttribToDisplay);
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);

        if (!this.AllocateMethodTransCatg) {
          if (this.baseFDIIData?.length > 0) this.singleBaseFDIIData = _.cloneDeep(this.baseFDIIData);
          if (this.baseBasketData?.length > 0) this.singleBaseBasketData = _.cloneDeep(this.baseBasketData);

          const fdiiEx = _.find(this.baseFDIIData, ['CODE_DESC', 'US Derived DEI']);
          if (fdiiEx) this.selectedBaseFdiiCodes = fdiiEx.CODE_KEY;
          const bbEx = _.find(this.baseBasketData, ['CODE_DESC', 'U.S.']);
          if (bbEx) this.selectedBaseBasketCode = bbEx.CODE_KEY;
        }
      }
      if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Interest Expense' ||
          this.selectedMethodCode?.CODE_DESCRIPTION === 'Research Expense') {
        const newList = _.cloneDeep(this.getAttribToDisplay);
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base FDII' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Basket' });
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      }
    }

    if (this.selectedGieName && (this.selectedGieName === 'EXPAA' || this.selectedGieName === 'ASTEXP' || this.selectedGieName === 'INVESTMENTS')) {
      if (this.selectedMethodCode && this.selectedMethodCode.CODE_DESCRIPTION !== 'Allocate' && this.selectedMethodCode.CODE_DESCRIPTION !== 'Gross Income') {
        this.baseTypeData = this.allGPTransCategoryData;
        this.syncDropdownList('baseType', this.baseTypeData);
        this.newArray = this.getAttribToDisplay ? this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME) : [];
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Allocate') {
        this.displaySingleSelectBase = 'true';
        if (!this.AllocateMethodTransCatg) {
          let fdiiEx = _.find(this.baseFDIIData, ['CODE_DESC', 'US Derived DEI']);
          if (!fdiiEx) fdiiEx = _.find(this.baseFDIIData, ['CODE_DESCRIPTION', 'US Derived DEI']);
          if (fdiiEx) this.selectedBaseFdiiCodes = fdiiEx.CODE_KEY;

          let bbEx = _.find(this.baseBasketData, ['CODE_DESC', 'U.S.']);
          if (!bbEx) bbEx = _.find(this.baseBasketData, ['CODE_DESCRIPTION', 'U.S.']);
          if (bbEx) this.selectedBaseBasketCode = parseInt(bbEx.CODE_KEY, 10);
        }
        const newList = _.cloneDeep(this.getAttribToDisplay);
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Level' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Type' });
        _.remove(newList, { ATTRIB_DISPLAY_NAME: 'Base Entity Level' });
        this.newArray = newList.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      } else if (this.selectedMethodCode?.CODE_DESCRIPTION === 'Gross Income') {
        this.gIncomeMethodFlag = 'true';
        this.baseTypeData = this.allTransCategoryData;
        this.syncDropdownList('baseType', this.baseTypeData);
        this.newArray = this.getAttribToDisplay.map((el: any) => el.ATTRIB_DISPLAY_NAME);
      }
    }
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  changeSelectedBeatWithHold(): void {
    if (this.selectedBeatWithhold && (this.selectedBeatWithhold < 0 || this.selectedBeatWithhold > 100)) {
      this.gtwSnackbar.openSnackBar('Please select BEAT Withhold between 0 to 100 only', 'gtw-snackbar--red', true, 5);
      this.isError = true;
    } else {
      this.isError = false;
    }
  }

  /* ─── Compare function for mat-select ─── */

  compareItems(a: any, b: any): boolean {
    return a && b && a.CODE_KEY == b.CODE_KEY;
  }

  /* ─── Save ─── */

  save(isSourceFlag: boolean): void {
    this.isSourceFlag = isSourceFlag;
    this.isSaveClicked = true;
    this.crudLoading = true;

    if (!this.selectedCodeCombination || !this.selectedGrossIncExp || !this.selectedTransCat) {
      this.gtwSnackbar.openSnackBar('Please select Entity, Gross Inc/Exp and Trans Category to proceed', 'gtw-snackbar--red', true, 4);
      this.isSaveClicked = false;
      return;
    }

    const returnObj: any = {};
    returnObj.COMBINATION_KEY = this.selectedCodeCombination.KEY;
    returnObj.GIE_KEY = this.selectedGrossIncExp.GIE_KEY;
    returnObj.OPERATION_TYPE = 'I';
    returnObj.TRANS_CATG_KEY = this.selectedTransCat;

    // Trading Partner validation
    const unrelatedExists = _.find(this.relatedCodeData, ['CODE_DESCRIPTION', 'UnRelated']);
    const disableTP = unrelatedExists && this.selectedRelatedCode == unrelatedExists.CODE_KEY;

    if (this.newArray.indexOf('Trading Partner') > -1 && !disableTP) {
      if (!this.selectedTradingPartnerCode || this.selectedTradingPartnerCode === '') {
        this.gtwSnackbar.openSnackBar('Please select Trading Partner to proceed', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false;
        return;
      }
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'ACTUAL_TP_KEY']);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = this.selectedTradingPartnerCode;
    }

    if (this.newArray.indexOf('Country') > -1) {
      if (!this.selectedCountryCode || this.selectedCountryCode === '') {
        this.gtwSnackbar.openSnackBar('Please select Country to proceed', 'gtw-snackbar--red', true, 4);
        this.isSaveClicked = false;
        return;
      }
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'COUNTRY']);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = this.selectedCountryCode;
    }

    // Simple field mappings
    this.setAttribField(returnObj, 'Basket', 'BASKET', this.selectedBasketCode);
    this.setAttribField(returnObj, 'SIC Code', 'SIC_CODES', this.selectedSicCode);
    this.setAttribField(returnObj, 'FDII', 'FDII', this.selectedFdiiCode);

    const beatAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT']);
    if (beatAttrib) returnObj[beatAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatCode;

    if (this.selectedBeatTypeCode && this.selectedBeatTypeCode !== '') {
      const btAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_TYPE']);
      if (btAttrib) returnObj[btAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatTypeCode;
    }

    const relAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'RELATED_UNRELATED']);
    if (relAttrib) returnObj[relAttrib.ATTRIB_KEY + '_0'] = this.selectedRelatedCode;

    const htkoAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'HTKO']);
    if (htkoAttrib) returnObj[htkoAttrib.ATTRIB_KEY + '_0'] = this.selectedHtkoCode;

    const fseAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'FSE']);
    if (fseAttrib) returnObj[fseAttrib.ATTRIB_KEY + '_0'] = this.selectedFsiCode;

    const stAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'SOURCE_TYPE']);
    if (stAttrib) returnObj[stAttrib.ATTRIB_KEY + '_0'] = this.selectedSourceTypeCode;

    const ptAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'PROJECT_TAGGING']);
    if (ptAttrib) returnObj[ptAttrib.ATTRIB_KEY + '_0'] = this.selectedProjectTaggingCode;

    const notesAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'NOTES']);
    if (notesAttrib) returnObj[notesAttrib.ATTRIB_KEY + '_0'] = this.selectedNotes;

    const ayAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'APPLICABLE_YEAR']);
    if (ayAttrib) returnObj[ayAttrib.ATTRIB_KEY + '_0'] = this.applicableYearKey;

    const lnAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'LINE_NO']);
    if (lnAttrib) returnObj[lnAttrib.ATTRIB_KEY + '_0'] = this.selectedLineNo;

    if (this.selectedBeatWithhold >= 0) {
      const bwAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BEAT_WITHHOLD']);
      if (bwAttrib) returnObj[bwAttrib.ATTRIB_KEY + '_0'] = this.selectedBeatWithhold;
    }

    // Base FDII / Base Basket / Base Type
    this.buildBaseFields(returnObj);

    // Method
    if (this.newArray.indexOf('Method') > -1 && this.selectedMethodCode) {
      const mAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'METHOD']);
      if (mAttrib) returnObj[mAttrib.ATTRIB_KEY + '_0'] = this.selectedMethodCode.CODE_KEY;
    }

    // Base Level / Base Entity Level
    if (this.newArray.indexOf('Base Level') > -1) {
      const blAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_LEVEL']);
      if (blAttrib) returnObj[blAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseLevelCode;
    }
    if (this.newArray.indexOf('Base Entity Level') > -1) {
      const beAttrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_ENTITY_LEVEL']);
      if (beAttrib) returnObj[beAttrib.ATTRIB_KEY + '_0'] = this.selectedBaseEntityLevelCode;
    }

    // Validations
    if (!this.validateSave(returnObj)) return;

    // Insert flow: get tag key sequence (k5eosd), then save
    const attribManagementChangeDetails = [returnObj];
    const returnClobSettingsObj: any = {
      sso_id: this.logged_in_user,
      screen_key: this.globalParams.screen_key,
      p_tax_year: this.curentyear,
      p_scenario: this.scenario,
      p_jcd_key: this.jcd_key,
    };

    const lockparams = { action_code: 'k5eosd' };
    this.jsonObjectFactory.getJSONObj(
      this.GENERAL_CONFIG.base_url + '/loadJsonObject', lockparams
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: any) => {
      const tagKeySeq = data?.jsonObject?.[0]?.TAG_KEY_SEQ;
      returnClobSettingsObj.tag_key = tagKeySeq;
      attribManagementChangeDetails[0].TAG_KEY = tagKeySeq;

      const checkLockObj = [{ combination_key: this.selectedCodeCombination.KEY }];
      const lockObj = { modal_name: 'addNewTag', lockingObj: checkLockObj };

      this.sendDetails(returnClobSettingsObj, attribManagementChangeDetails, 'Tag has been successfully saved/updated', lockObj);
    });
  }

  private sendDetails(settings: any, details: any[], message: string, lockObj?: any): void {
    this.addNewTagService.saveDefaults(
      this.GENERAL_CONFIG.base_url,
      this.globalParams,
      this.filterParams,
      settings,
      details,
      lockObj
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: any) => {
      if (result?.data?.errorMessage && result.data.errorMessage !== 'null') {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this.gtwSnackbar.openSnackBar(result.data.errorMessage, 'gtw-snackbar--red', true, 4);
      } else {
        this.crudLoading = false;
        this.gtwSnackbar.openSnackBar(message, 'gtw-snackbar--green', true, 4);
        if (this.isSourceFlag && settings?.tag_key != null) {
          this.emitRequestGridUpdate({
            action: 'refresh',
            openSource: true,
            tagKey: settings.tag_key,
          });
        } else {
          this.emitRequestGridUpdate('refresh');
        }
        this.isSourceFlag = false;
      }
      this.cdr.detectChanges();
    });
  }

  private emitRequestGridUpdate(detail: any): void {
    this.requestGridUpdate.emit(detail);
    let host: HTMLElement | null = this.elementRef?.nativeElement ?? null;
    while (host && host.tagName !== 'GTW-ADD-NEW-TAG-CE' && host !== document.body) {
      host = host.parentElement;
    }
    if (!host) {
      host = document.querySelector('gtw-add-new-tag-ce');
    }
    if (host) {
      host.dispatchEvent(
        new CustomEvent('request-grid-update', { detail, bubbles: true, composed: true })
      );
    }
  }

  private setAttribField(returnObj: any, displayName: string, attribName: string, value: any): void {
    if (this.newArray.indexOf(displayName) > -1) {
      const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
      if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = value;
    }
  }

  private buildBaseFields(returnObj: any): void {
    if (this.displaySingleSelectBase === 'true') {
      if (this.selectedBaseFdiiCodes != null && this.selectedBaseFdiiCodes !== '' && this.newArray.indexOf('Base FDII') > -1) {
        returnObj.BASE_FDII_DATA = this.selectedBaseFdiiCodes;
        const singleEx = _.find(this.basefdiiSingleMultiData, ['CODE_DESC', 'SINGLE']);
        if (singleEx) {
          const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_FDII']);
          if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = singleEx.CODE_KEY;
        }
      }
      if (this.selectedBaseBasketCode != null && this.selectedBaseBasketCode !== '' && this.newArray.indexOf('Base Basket') > -1) {
        returnObj.BASE_BASKET_DATA = this.selectedBaseBasketCode;
        const singleEx = _.find(this.baseBasketTypeData, ['CODE_DESCRIPTION', 'SINGLE']);
        if (singleEx) {
          const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', 'BASE_BASKET']);
          if (attrib) returnObj[attrib.ATTRIB_KEY + '_0'] = singleEx.CODE_KEY;
        }
      }
    } else {
      // Multi-select Base FDII
      if (this.newArray.indexOf('Base FDII') > -1 && Array.isArray(this.selectedBaseFdiiCodes)) {
        let baseFdiiSelected = '';
        for (const d of this.selectedBaseFdiiCodes) {
          if (d?.CODE_KEY != undefined) baseFdiiSelected += d.CODE_KEY + ',';
        }
        if (baseFdiiSelected) returnObj.BASE_FDII_DATA = baseFdiiSelected.substring(0, baseFdiiSelected.length - 1);
        this.setMultiSingleAllKey(returnObj, this.selectedBaseFdiiCodes, this.baseFDIIData, this.basefdiiSingleMultiData, 'BASE_FDII', 'CODE_DESC');
      }
      // Multi-select Base Basket
      if (this.newArray.indexOf('Base Basket') > -1 && Array.isArray(this.selectedBaseBasketCode)) {
        let baseBasketSelected = '';
        for (const d of this.selectedBaseBasketCode) {
          if (d?.CODE_KEY != undefined) baseBasketSelected += d.CODE_KEY + ',';
        }
        if (baseBasketSelected) returnObj.BASE_BASKET_DATA = baseBasketSelected.substring(0, baseBasketSelected.length - 1);
        this.setMultiSingleAllKey(returnObj, this.selectedBaseBasketCode, this.baseBasketData, this.baseBasketTypeData, 'BASE_BASKET', 'CODE_DESCRIPTION');
      }
    }

    // Base Type
    if (this.newArray.indexOf('Base Type') > -1 && Array.isArray(this.selectedBaseTypeCode)) {
      let baseTypeSelected = '';
      for (const d of this.selectedBaseTypeCode) {
        if (d?.CODE_KEY != undefined) baseTypeSelected += d.CODE_KEY + ',';
      }
      if (baseTypeSelected) returnObj.BASE_TYPE_DATA = baseTypeSelected.substring(0, baseTypeSelected.length - 1);
      this.setMultiSingleAllKey(returnObj, this.selectedBaseTypeCode, this.baseTypeData, this.baseTypeCodeData, 'BASE_TYPE', 'CODE_DESCRIPTION');
    }

    // Clear "ALL" selections
    if (this.selectedMethodCode?.CODE_DESCRIPTION !== 'Allocate') {
      if (returnObj.BASE_FDII_DATA && this.baseFDIIData && returnObj.BASE_FDII_DATA.split(',').length === this.baseFDIIData.length) {
        returnObj.BASE_FDII_DATA = '';
      }
      if (returnObj.BASE_BASKET_DATA && this.baseBasketData && returnObj.BASE_BASKET_DATA.split(',').length === this.baseBasketData.length) {
        returnObj.BASE_BASKET_DATA = '';
      }
      if (returnObj.BASE_TYPE_DATA && this.baseTypeData && returnObj.BASE_TYPE_DATA.split(',').length === this.baseTypeData.length) {
        returnObj.BASE_TYPE_DATA = '';
      }
    }
  }

  private setMultiSingleAllKey(returnObj: any, selected: any[], allData: any[], typeData: any[], attribName: string, codeField: string): void {
    const attrib = _.find(this.attribMastData, ['ATTRIB_NAME', attribName]);
    if (!attrib) return;
    if (selected?.length === 1) {
      const exists = _.find(typeData, [codeField, 'SINGLE']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected && allData && selected.length === allData.length) {
      const exists = _.find(typeData, [codeField, 'ALL']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    } else if (selected?.length > 1) {
      const exists = _.find(typeData, [codeField, 'MULTI']);
      if (exists) returnObj[attrib.ATTRIB_KEY + '_0'] = exists.CODE_KEY;
    }
  }

  private validateSave(returnObj: any): boolean {
    if (this.newArray.indexOf('Base FDII') > -1 && this.displaySingleSelectBase === 'true' &&
        (this.selectedBaseFdiiCodes === '' || this.selectedBaseFdiiCodes == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Basket') > -1 && this.displaySingleSelectBase === 'true' &&
        (this.selectedBaseBasketCode === '' || this.selectedBaseBasketCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base FDII') > -1 && Array.isArray(this.selectedBaseFdiiCodes) && this.selectedBaseFdiiCodes.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Basket') > -1 && Array.isArray(this.selectedBaseBasketCode) && this.selectedBaseBasketCode.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Type') > -1 && Array.isArray(this.selectedBaseTypeCode) && this.selectedBaseTypeCode.length === 0) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Type', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Level') > -1 && (this.selectedBaseLevelCode === '' || this.selectedBaseLevelCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Level', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Base Entity Level') > -1 && (this.selectedBaseEntityLevelCode === '' || this.selectedBaseEntityLevelCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Base Entity Level', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Basket') > -1 && (this.selectedBasketCode === '' || this.selectedBasketCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Basket', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('FDII') > -1 && (this.selectedFdiiCode === '' || this.selectedFdiiCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select FDII', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('Source Type') > -1 && (this.selectedSourceTypeCode === '' || this.selectedSourceTypeCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select Source Type', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if (this.newArray.indexOf('SIC Code') > -1 && (this.selectedSicCode === '' || this.selectedSicCode == null)) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select SIC Code', 'gtw-snackbar--red', true, 4);
      return false;
    }
    if ((this.selectedBeatCodeDesc === 'Yes' && (this.selectedBeatWithhold === undefined || this.selectedBeatWithhold === '' || this.selectedBeatWithhold === null)) ||
        (this.selectedBeatWithhold && (this.selectedBeatWithhold < 0 || this.selectedBeatWithhold > 100))) {
      this.isSaveClicked = false;
      this.gtwSnackbar.openSnackBar('Please select BEAT Withhold between 0 to 100 only', 'gtw-snackbar--red', true, 5);
      return false;
    }
    return true;
  }

  /* ─── Reset ─── */

  reset(): void {
    this.selectedCodeCombination = undefined;
    this.selectedGrossIncExp = undefined;
    this.selectedTransCat = undefined;
    this.flagForNewUpdate = -1;
    this.isMethodChangedManually = false;
    this.selectedBasketCode = undefined;
    this.selectedSicCode = undefined;
    this.selectedFdiiCode = undefined;
    this.selectedBeatTypeCode = undefined;
    this.selectedBeatCode = undefined;
    this.selectedBeatCodeDesc = '';
    this.selectedRelatedCode = undefined;
    this.selectedRelatedCodeDesc = '';
    this.selectedTradingPartnerCode = undefined;
    this.selectedCountryCode = undefined;
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.selectedSourceTypeCode = undefined;
    this.selectedProjectTaggingCode = undefined;
    this.selectedNotes = undefined;
    this.selectedMethodCode = undefined;
    this.selectedBaseFdiiCodes = undefined;
    this.selectedBaseBasketCode = undefined;
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = undefined;
    this.selectedBaseEntityLevelCode = undefined;
    this.selectedBeatWithhold = undefined;
    this.newArray = [];
    this.isSaveClicked = false;
        this.refreshFormDropdowns();
    this.cdr.detectChanges();
  }

  /* ─── Cancel ─── */

  cancel(): void {
    this.emitRequestGridUpdate('cancel');
  }

  /* ─── Helpers ─── */

  private resetDependentFields(): void {
    this.selectedTransCat = undefined;
    this.selectedBasketCode = undefined;
    this.selectedSicCode = undefined;
    this.selectedFdiiCode = undefined;
    this.selectedBeatTypeCode = undefined;
    this.selectedBeatCodeDesc = '';
    this.selectedRelatedCode = undefined;
    this.selectedTradingPartnerCode = undefined;
    this.selectedCountryCode = undefined;
    this.selectedHtkoCode = undefined;
    this.selectedFsiCode = undefined;
    this.selectedSourceTypeCode = undefined;
    this.selectedProjectTaggingCode = undefined;
    this.selectedNotes = undefined;
    this.selectedMethodCode = undefined;
    this.selectedBaseFdiiCodes = undefined;
    this.selectedBaseBasketCode = undefined;
    this.selectedBaseTypeCode = [];
    this.selectedBaseLevelCode = undefined;
    this.selectedBaseEntityLevelCode = undefined;
    this.selectedBeatWithhold = undefined;
  }

  private uniqueData(arrayData: any[], filterBy: string): any[] {
    const elementIds: any[] = [];
    return arrayData.filter(el => {
      if (elementIds.indexOf(el[filterBy]) === -1) {
        elementIds.push(el[filterBy]);
        return true;
      }
      return false;
    });
  }


  getTradingPartnerList(): any[] {
    if ((this.selectedRelatedCodeDesc === 'Related Domestic' || this.selectedRelatedCodeDesc === '') &&
        (this.selectedBeatCodeDesc === 'No' || this.selectedBeatCodeDesc === '')) {
      return this.domesticTradingPartnerData;
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign' && this.selectedBeatCodeDesc === 'Yes') {
      return this.beatYesforeignTradingPartnerData;
    }
    if (this.selectedRelatedCodeDesc === 'Related Foreign' && (this.selectedBeatCodeDesc === 'No' || this.selectedBeatCodeDesc === '')) {
      return this.beatNoforeignTradingPartnerData;
    }
    return this.tradingPartnerCodeData;
  }

  rebuildTradingPartnerOptions(): void {
    this.tradingPartnerOptions = this.getTradingPartnerList().map((tp: any) => ({
      label: tp.LE_NAME,
      value: tp.COMBINATION_KEY,
    }));
    this.refreshFormDropdowns();
  }


  onDropdownFilterResult(key: string, event: any): void {
    this.dropdownLists[key] = event?.result || [];
  }

  private toAppkitOptions(items: any[]): any[] {
    return (items || []).map((item: any) => {
      item.showCheckbox = true;
      item.role = 'checkbox';
      return item;
    });
  }

  private syncDropdownList(key: string, master: any[]): void {
    this.dropdownLists[key] = this.toAppkitOptions(master).slice();
  }

  private refreshFormDropdowns(): void {
    refreshNamedDropdown(this, 'entityOptions', 'selectedCodeCombination', 'label', 'value');
    refreshNamedDropdown(this, 'grossIncExpData', 'selectedGrossIncExp', 'GIE_DESC', 'GIE_KEY');
    refreshNamedDropdown(this, 'transCategoryData', 'selectedTransCat', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'basketCodeData', 'selectedBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'sicCodeData', 'selectedSicCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'fdiiCodeData', 'selectedFdiiCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'filteredTaxYearData', 'applicableYearKey', 'CODE_DESC', 'CODE_KEY');
    refreshNamedDropdown(this, 'lineNoCodeData', 'selectedLineNo', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'yesNoData', 'selectedBeatCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'beatTypeData', 'selectedBeatTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'relatedCodeData', 'selectedRelatedCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'tradingPartnerOptions', 'selectedTradingPartnerCode', 'label', 'value');
    refreshNamedDropdown(this, 'countryCodeData', 'selectedCountryCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'htkoData', 'selectedHtkoCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'fsiData', 'selectedFsiCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'sourceTypeCodeData', 'selectedSourceTypeCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'projectTagCodeData', 'selectedProjectTaggingCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'methodCodeData', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseFDIIData', 'selectedBaseFdiiCodes', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'basketCodeAllocateData', 'selectedBaseBasketCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseLevelData', 'selectedBaseLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
    refreshNamedDropdown(this, 'baseEntityData', 'selectedBaseEntityLevelCode', 'CODE_DESCRIPTION', 'CODE_KEY');
  }

  onChangeEntityFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedCodeCombinationItem', 'selectedCodeCombination', 'label', 'value', 'entityOptionsView', () => this.changeEntity());
  }
  onOnGrossIncExpChangeFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedGrossIncExpItem', 'selectedGrossIncExp', 'GIE_DESC', 'GIE_KEY', 'grossIncExpDataView', () => this.onGrossIncExpChange());
  }
  onUpdateCountryFieldFromDropdown(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedTransCatItem', 'selectedTransCat', () => this.updateCountryField(true));
  }
  onChangeBasketCodeFromDropdown(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBasketCodeItem', 'selectedBasketCode', () => this.changeBasketCode());
  }
  onSelectedSicCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedSicCodeItem', 'selectedSicCode');
  }
  onSelectedFdiiCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedFdiiCodeItem', 'selectedFdiiCode');
  }
  onApplicableYearKeySelect(event: any): void {
    handleAppkitValueSelect(event, this, 'applicableYearKeyItem', 'applicableYearKey');
  }
  onSelectedLineNoSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedLineNoItem', 'selectedLineNo');
  }
  onChangeBeatCodeFromDropdown(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBeatCodeItem', 'selectedBeatCode', () => this.changeBeatCode());
  }
  onSelectedBeatTypeCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBeatTypeCodeItem', 'selectedBeatTypeCode');
  }
  onChangeRelatedCodeFromDropdown(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedRelatedCodeItem', 'selectedRelatedCode', () => this.changeRelatedCode());
  }
  onChangeTradingPartnerFromDropdown(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedTradingPartnerCodeItem', 'selectedTradingPartnerCode', () => this.changeTradingPartner());
  }
  onSelectedCountryCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedCountryCodeItem', 'selectedCountryCode');
  }
  onSelectedHtkoCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedHtkoCodeItem', 'selectedHtkoCode');
  }
  onSelectedFsiCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedFsiCodeItem', 'selectedFsiCode');
  }
  onSelectedSourceTypeCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedSourceTypeCodeItem', 'selectedSourceTypeCode');
  }
  onSelectedProjectTaggingCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedProjectTaggingCodeItem', 'selectedProjectTaggingCode');
  }
  onChangeInCreateMethodFromDropdown(event: any): void {
    handleNamedDropdownSelect(event, this, 'selectedMethodCodeItem', 'selectedMethodCode', 'CODE_DESCRIPTION', 'CODE_KEY', 'methodCodeDataView', () => this.changeInCreateMethod());
  }
  onSelectedBaseFdiiCodesSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBaseFdiiCodesItem', 'selectedBaseFdiiCodes');
  }
  onSelectedBaseBasketCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBaseBasketCodeItem', 'selectedBaseBasketCode');
  }
  onSelectedBaseLevelCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBaseLevelCodeItem', 'selectedBaseLevelCode');
  }
  onSelectedBaseEntityLevelCodeSelect(event: any): void {
    handleAppkitValueSelect(event, this, 'selectedBaseEntityLevelCodeItem', 'selectedBaseEntityLevelCode');
  }

  onDropdownSelectItem(_event: any): void {}


}
